import { render, staticRenderFns } from "./facturased.vue?vue&type=template&id=dabf1422"
import script from "./facturased.vue?vue&type=script&lang=js"
export * from "./facturased.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports